// 20.1.2.3 Number.isInteger(number)
var $export = require('./_export');

$export($export.S, 'Number', { isInteger: require('./_is-integer') });



// WEBPACK FOOTER //
// c:/Users/Antanas/Dropbox/am/Projects/typescript/amcharts4dev/node_modules/core-js/modules/es6.number.is-integer.js